// Services
import { UrlsService } from 'NewAngular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/urls.service";
const _c0 = ["ycn-notifications-menu-report-history-item", ""];
export class NotificationsMenuReportHistoryItemComponent {
    constructor(urlsService) {
        this.urlsService = urlsService;
        this.reportDate = '';
        this.displayTitle = '';
        this.downloadUrl = '';
    }
    ngOnInit() {
        this.displayTitle = this.report.title?.trim() || 'Untitled Report';
        this.downloadUrl = this.urlsService.getUrl(this.urlsService.COMPLIANCE.DOWNLOAD_REPORT, {
            complianceReportId: this.report.id,
        });
        this.reportDate = new Date(this.report.create_date).toLocaleString('default', {
            month: 'short',
            day: '2-digit',
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
        });
    }
}
NotificationsMenuReportHistoryItemComponent.ɵfac = function NotificationsMenuReportHistoryItemComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || NotificationsMenuReportHistoryItemComponent)(i0.ɵɵdirectiveInject(i1.UrlsService)); };
NotificationsMenuReportHistoryItemComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NotificationsMenuReportHistoryItemComponent, selectors: [["tr", "ycn-notifications-menu-report-history-item", ""]], inputs: { report: "report" }, standalone: false, attrs: _c0, decls: 8, vars: 3, consts: [[1, "notification-title", "unread"], [1, "bullet", "bullet-blue"], ["target", "_blank", 3, "href"], [1, "notification-date"]], template: function NotificationsMenuReportHistoryItemComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "td")(1, "div", 0);
        i0.ɵɵelement(2, "div", 1);
        i0.ɵɵelementStart(3, "span")(4, "a", 2);
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(6, "div", 3);
        i0.ɵɵtext(7);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("href", ctx.downloadUrl, i0.ɵɵsanitizeUrl);
        i0.ɵɵadvance();
        i0.ɵɵtextInterpolate(ctx.displayTitle);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.reportDate);
    } }, encapsulation: 2 });
